import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=13178b0e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13178b0e')) {
      api.createRecord('13178b0e', component.options)
    } else {
      api.reload('13178b0e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=13178b0e&", function () {
      api.rerender('13178b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dw0iCB8iJy7y/JS/comp/openstreetmap.vue"
export default component.exports